import { z } from 'zod';
/**
 * Payloads of the `ingredients` Edge Function, and of
 * `save_ingredient_override`, which the app calls straight through PostgREST.
 *
 * Free of any relative import: the function loads this file, and neither Deno
 * nor the Supabase CLI — which mounts every file a function imports when the
 * stack starts — resolves the `.js` specifiers TypeScript requires.
 */
/** The family's own card for an ingredient: only the fields sent are written. */
export const IngredientOverrideSchema = z.object({
    description: z.string().optional(),
    cooking_methods: z.array(z.record(z.unknown())).optional(),
    preparation_tips: z.array(z.string()).optional(),
    conservation: z.record(z.unknown()).optional(),
    general_tips: z.array(z.string()).optional(),
});
//# sourceMappingURL=ingredient-requests.js.map